var _rect, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 16",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v2H0Zm0 4h24v2H0Zm0 4h24v2H0Zm0 4h24v2H0Z",
    fill: "#b22234"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h10.2v8H0Z",
    fill: "#3c3b6e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 1.5,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 1.5,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 1.5,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 1.5,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 3,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 3,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 3,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 4.5,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4.5,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 4.5,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4.5,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 6,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 6,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 6,
    r: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 6,
    r: 0.35
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.e1811594b097231f95f61f3710cd2715.svg";
export { ForwardRef as ReactComponent };